import axios from 'axios'
const api = "configurar"

const cedisDiasMuertos = {
    getCedis: () => axios.get(`${api}/get-cedis-dias`),
    setDia: (cedi,params) => axios.put(`${api}/${cedi}/set-dia`,params)
}
export default cedisDiasMuertos